import { computed } from 'vue'
import { defineStore } from 'pinia'
import { BrandName } from '../models/types'
import { BAGY_HOSTNAMES } from '../models/bagy'
import { TRAY_HOSTNAMES } from '../models/tray'

function detectBrand (): BrandName {
  const hostname = window.location.hostname

  if (BAGY_HOSTNAMES.includes(hostname)) {
    return BrandName.BAGY
  }

  if (TRAY_HOSTNAMES.includes(hostname)) {
    return BrandName.TRAY
  }

  return BrandName.CPLUG
}

export const useBrandStore = defineStore('brand', () => {
  const current = computed<BrandName>(() => detectBrand())

  const isBagy = computed(() => current.value === BrandName.BAGY)
  const isTray = computed(() => current.value === BrandName.TRAY)
  const isCplug = computed(() => current.value === BrandName.CPLUG)
  const isPartnerBrand = computed(() => isTray.value || isBagy.value)

  return {
    current,
    isBagy,
    isCplug,
    isPartnerBrand,
    isTray
  }
})
